<template>
  <main id='wrapper' :class='{fade: showMenu}'>
    <MainHeader/>
    <ViewTransitions @transitionStarted="started" @transitionEnded="ended"/>
    <!--<SoundFooter/>-->
  </main>
</template>

<script setup>
import { useStore } from './KQL.js'
import { routeStore } from '@/utils'

import { composables } from '@/composables';
const showMenu = composables().showMenu;

//Get route so we know where we are.
const route = useRoute();
const routes = routeStore();

//Setup Kirby (Timeout just so we don't load it too quickly.)
const kql = useStore();
setTimeout(function() { kql.loadPageAndSite(route.path, route.name) });

//Bind Router and KQLStore
watch(route, (route) => kql.loadPage(route.path, route.name));

//Watch transition emits.
const transitionActive = ref(false)
const started = () => {transitionActive.value = true}
const ended = () => {transitionActive.value = false}
</script>

<style scoped>
  main {
    min-height: calc(100vh - 50rem);
    position: relative;
  }

  main main {
    transition: all 200ms ease-out;
    opacity: 1;
    filter: blur(0px);
  }

  main.fade main {
    opacity: 0.6;
    filter: blur(40px);
  }

  main.fade :deep(canvas) {
    opacity: 0.0;
  }

  main :deep(nav.player) {
    transition: transform 150ms ease-out, opacity 150ms ease-out;
  }

  main.fade :deep(nav.player) {
    transform: translateY(-5rem);
    opacity: 0;
    pointer-events: none;
  }

  main.fade header :deep(h1) {
    position: fixed;
  }
</style>
